module.exports = __webpack_public_path__ + "static/media/Beetlebots.910b0777.md";